import {defineStore} from 'pinia'
import {CountryCodeInformation, CountryCodeInformationByCountryCode, getCountriesCode} from "@/api/countryCode";
import {isUndefined} from "lodash";

type CountriesInfosArray = [string, CountryCodeInformation][];

type CountriesInfosGroupedByRegion = Record<string, CountryCodeInformationByCountryCode>;


export const useCountryCodeStore = defineStore('countryCode', {
    state: () => ({
        countriesInfos: {} as CountryCodeInformationByCountryCode,
        isLoading: false,
    }),
    getters: {
        countriesInfosArray(): CountriesInfosArray {
            return Object.entries(this.countriesInfos);
        },
        availableCountriesInfosArray(): CountriesInfosArray {
            return Object.entries(this.countriesInfos).filter(([k, c]) => c.availableToAdministrator);
        },
        countriesInfosGroupedByRegion(): CountriesInfosGroupedByRegion {
            return getCountriesInfosGroupedByRegion(this.countriesInfosArray);
        },
        availableCountriesInfosGroupedByRegion(): CountriesInfosGroupedByRegion {
            return getCountriesInfosGroupedByRegion(this.availableCountriesInfosArray);
        },
        availableCountryCodeList(): string[] {
            return this.availableCountriesInfosArray.map(([k, c]) => k);
        },
    },
    actions: {
        async loadCountries(): Promise<void> {
            if (this.countriesInfosArray.length !== 0 || this.isLoading) {
                return;
            }

            this.countriesInfos = await getCountriesCode();
            this.isLoading = false;
        },
    },
});

function getCountriesInfosGroupedByRegion(countriesInfosArray: CountriesInfosArray): CountriesInfosGroupedByRegion {
    return countriesInfosArray.reduce<CountriesInfosGroupedByRegion>((acc, [c, infos]) => {
        if (isUndefined(acc[infos.region])) {
            acc[infos.region] = {};
        }
        acc[infos.region][c] = infos;
        return acc;
    }, {});
}
